import { getLayerExist, getExistLayerList } from './layerStatusControl'

function getLayerZIndex (params, self) {
  if (!self) {
    self = this
  }

  const infoAll = getLayerExist(params)
  if (!infoAll) {
    return null
  }
  const info = infoAll.info
  const zIndex = info.zIndex
  return zIndex
}

function setIndexNumByParam (params, self) {
  /* 获取当前图层 */
  const layerThis = getLayerExist(params)
  if (!layerThis) {
    return null
  }
  const layerThisMarket = layerThis.market
  if (!layerThisMarket) {
    return null
  }

  if (params.zIndex) {
    const _zIndex = params.zIndex
    if (_zIndex <= 55000 && _zIndex >= 50001) { params.layerGroup = 'baseVector' }
    if (_zIndex <= 50000 && _zIndex >= 45001) { params.layerGroup = 'geoBound' }
    if (_zIndex <= 45000 && _zIndex >= 40001) { params.layerGroup = 'vector' }
    if (_zIndex <= 40000 && _zIndex >= 10001) { params.layerGroup = 'other' }
    if (_zIndex <= 10000 && _zIndex >= 9001) { params.layerGroup = 'productImage' }
    if (_zIndex <= 9000 && _zIndex >= 8001) { params.layerGroup = 'baseImage' }
    if (_zIndex <= 8000 && _zIndex >= 7001) { params.layerGroup = 'map' }
  }

  /* 获取当前图层的zIndex */
  const zIndexThis = self.viewer.imageryLayers.indexOf(layerThisMarket) - 1
  const layerListAll = getExistLayerList()
  /* 获取当前图层所在图层组 */
  const zIndexList = layerListAll.filter((item) => {
    return item.info.layerGroup === params.layerGroup
  })
  /* 获取当前图层所在图层组的第一个index */
  const groupIndex = layerListAll.findIndex(item => item.info.layerGroup === params.layerGroup);

  /* 需要上升或者下降的层数 */
  const rasieNum = groupIndex + zIndexList.length - 1 - zIndexThis

  /*
  * console.log('图层组的第一个index: ', groupIndex)
  * console.log('当前图层组个数: ', zIndexList.length)
  * console.log('之前所在的zindex: ', zIndexThis)
  * console.log('需要上升或者下降的层数', rasieNum)
  */

  // console.log('图层组的第一个index: ', groupIndex)
  // console.log('当前图层组个数: ', zIndexList.length)
  // console.log('之前所在的zindex: ', zIndexThis)
  // console.log('需要上升或者下降的层数', rasieNum)

  handleLayerParam(rasieNum, self.viewer, layerThisMarket)
}

function handleLayerParam (rasieNum, viewer, layer) {
  if (rasieNum === 0) {
    return false
  }
  const imageryLayers = viewer.imageryLayers
  if (rasieNum > 0) {
    for (let i = 0; i < rasieNum; i++) {
      imageryLayers.raise(layer)
    }
  } else {
    rasieNum = -rasieNum
    for (let i = 0; i < rasieNum; i++) {
      imageryLayers.lower(layer)
    }
  }
  return true
}

function setLayerZIndex (params, setLayerZIndex, self) {
  if (!self) {
    self = this
  }
  if (!setLayerZIndex) {
    return
  }
  params.zIndex = setLayerZIndex
  setIndexNumByParam(params, self)
}

export { getLayerZIndex, setLayerZIndex }
